/* eslint-disable consistent-return */
import { useEffect, useState, useReducer } from 'react'

const initState = {
  response: null,
  pending: false,
  error: false,
  complete: false,
  load: false,
}

const endpointDataReducer = (state, { type, response, err }) => {
  switch (type) {
    case 'pending':
      return { ...state, pending: true, complete: false, error: null }
    case 'complete':
      // NOTE: Axios calls are wrapped in response.data. XMPP calls are just response.
      return { ...state, pending: false, complete: true, load: false, response: response?.data || response }
    case 'load':
      return { ...state, load: true }
    case 'error':
      return { ...state, error: err, complete: true, pending: false, load: false }
    default:
      return state
  }
}

export default function useEndpointAsFunction(endpointFunction) {
  const [epState, dispatch] = useReducer(endpointDataReducer, initState)
  const [args, setArgs] = useState()
  const funcReturn = (...newArgs) => {
    setArgs(newArgs)
  }

  useEffect(() => {
    let subscribe = true
    if (!args) return
    dispatch({ type: 'pending' })
    endpointFunction(...args)
      .then((response) => {
        if (subscribe) dispatch({ type: 'complete', response })
      })
      .catch((err) => {
        if (subscribe) dispatch({ type: 'error', err })
      })

    return () => {
      subscribe = false
    }
  }, [args, endpointFunction])

  return [epState, dispatch, funcReturn]
}
